class searchView {
  _parentEl = document.querySelector(`.search`);

  getQuery() {
    const query = this._parentEl.querySelector(`.search__field`).value;
    this._clearQuery();
    return query;
  }

  _clearQuery() {
    this._parentEl.querySelector(`.search__field`).value = '';
    this._parentEl.querySelector(`.search__field`).blur();
  }

  searchHandler(subscriber) {
    this._parentEl.addEventListener(`submit`, function (e) {
      e.preventDefault();
      subscriber();
    });
  }
}

export default new searchView();
